import { render, staticRenderFns } from "./CampaignSettings.vue?vue&type=template&id=83b6d51e"
import script from "./CampaignSettings.vue?vue&type=script&lang=js"
export * from "./CampaignSettings.vue?vue&type=script&lang=js"
import style0 from "./CampaignSettings.vue?vue&type=style&index=0&id=83b6d51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports